export const state = () => ({

});
export const mutations = {
  setCookiesAbTest: function (state, cookiesName) {
    const cookie = this.$cookies.get(cookiesName);
    if (String(cookie) && cookie !== undefined && cookie !== null) {
      return
    }

    const isUserTest = Boolean(Math.random() > 0.5);
    this.$cookies.set(cookiesName, String(isUserTest), {
      path: "/",
      maxAge: 60 * 60 * 24 * 30 * 12,
    });

    if (this.$yandexMetrika?.userParams) {
      this.$yandexMetrika.userParams({
        [cookiesName]: String(isUserTest)
      });
    }
  }
}
